module.exports = __webpack_public_path__ + "img/855D08_DAC31B_BF9B0C_AF860C-256px.1786d468.png";